export const ACCESS_CODE_LENGTH = 5;

const ACCESS_CODE_CHAR_PATTERN = /[A-Za-z0-9]/g;

export function normalizeAccessCode(raw: string): string {
  const withoutSpaces = raw.replace(/\s/g, "");
  const chars = withoutSpaces.match(ACCESS_CODE_CHAR_PATTERN) ?? [];
  return chars.join("").toUpperCase().slice(0, ACCESS_CODE_LENGTH);
}
